import React from 'react';
import { Link } from 'react-router-dom';
import {BASE_URL, isNullEmptyOrWhitespace} from '../../constants';
import PropTypes from 'prop-types';
import moment from 'moment';
import {PickupNoteSummary} from "../Pickups/PickupNoteSummary";
import {getCollectionAction, getRunFlag, getRunFlagBadgeClass, getRunFlagIcon, getRunTypeCardStyle} from '../../utils/collectionTypes';

const Runs = (props) => {
  let {runs, loadRuns, userName, isAdmin, hideReload, pathSegment} = props;

  return (<div>
    <div className="row">
      <div className="col-md-12">
        {runs.loaded &&  <h5>
          { userName != '' && <strong>{userName.charAt(0).toUpperCase() + userName.slice(1)}, you have {runs.items.length} run(s)&nbsp;&nbsp;</strong>}
          { !hideReload && <button type="button" className="btn btn-primary" onClick={loadRuns}><i className="fa fa-refresh" />&nbsp;Reload runs</button> }
          { userName == '' && <span>Found {runs.items.length} runs</span> }
        </h5>}
        {!runs.loaded && <h5>
          <p>Loading runs... <i className="fa fa-cog fa-spin fa-2x" /></p>
        </h5>}
      </div>
    </div>
    {runs.items.map(run =>
          (<div className="row" key={run.id}>
            <div className="col-md-8">
              <div className="card" key={run.regionsVisited} style={getRunTypeCardStyle(run.truckCollectionTypeCode)}>
                <div className="card-block">
                  <h5 className="card-title">
                    {run.isComplete && <span className="badge badge-success">Run Complete</span>}
                    {!run.isComplete && <span className="badge badge-warning">Run Incomplete</span>}                    
                    <span className={getRunFlagBadgeClass(run.truckCollectionTypeCode) + ' ml-1'}><i className={getRunFlagIcon(run.truckCollectionTypeCode)}/> {getRunFlag(run.truckCollectionTypeCode)}</span>
                    { run.dateModified != '0001-01-01T00:00:00' && <span className="text-muted pull-right" style={{fontSize:'small'}}><i className="fa fa-save"/>&nbsp;{moment(run.dateModified).format('ddd, Do, LT')}</span> }
                  </h5>
                  <h6>{run.runDate}</h6>
                  <h4><Link style={{padding: 0}} to={`${BASE_URL}/runs/${pathSegment}/${run.id}`} className="nav-link">{run.regionsVisited} - {run.truckName}</Link></h4>
                  <h6><strong>Driver:</strong> {run.driverFullName}</h6>
                  <p className="card-text"><i className="fa fa-shopping-cart" />&nbsp; { `${parseFloat(run.totalLitres).toFixed(0)} L to be ${getCollectionAction(run.truckCollectionTypeCode)}`}</p>
                  <p className="card-text"><i className="fa fa-battery-full" />&nbsp; { `${parseFloat(run.totalEstimatedLitresPickedUp).toFixed(2)} L ${getCollectionAction(run.truckCollectionTypeCode)}`}</p>
                  <p className="card-text"><i className="fa fa-tachometer" />&nbsp; { `${run.pickupsComplete}/${run.pickupsToComplete}`} locations complete</p>
                  { (run.pickupsToComplete-run.pickupsComplete == 0) && run.isBaseCheckedIn && !run.isBaseCheckedOut && <p className="card-text text-danger"><i className="fa fa-warning" /> Must check out of final location</p> }
                  <div>
                    {run.pickups.map((p) => <PickupNoteSummary key={p.id} pickup={p}  />)}
                  </div>            
                  {run.lastPickupDate && <p>
                    <span className="font-weight-bold text-primary">Last checkin: </span>
                    <span>{moment(run.lastPickupDate).format('ddd, Do, LT')}</span>
                  </p>}
                </div>
              </div>
            </div>
          </div>)
      )}
  </div>);
};

Runs.propTypes = {
  runs: PropTypes.object.isRequired,
  loadRuns: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  hideReload: PropTypes.bool,
  pathSegment: PropTypes.string.isRequired,
};

export default Runs;
